import { useNavigate, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useShopsQuery } from "../api/queries";
import { ShopsFilter } from "../ui/ShopsFilter";
import { ShopsStatsCards } from "../ui/ShopsStatsCards";
import { ShopsTable } from "../ui/ShopsTable";
import { ShopsToolbar } from "../ui/ShopsToolbar";

export function ShopsPage() {
  const nav = useNavigate({ from: "/app/shops" });
  const search: OffsetPageQueryDTO = useSearch({ from: "/app/shops" });

  const list = useShopsQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຮ້ານຄ້າ" },
          ]}
        />
      </Header>

      <Main>
        <ShopsToolbar />

        <ShopsStatsCards />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <ShopsFilter />

          <ShopsTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={search.sort ? search.sort[0]?.field : undefined}
            sortOrder={
              search.sort ? (search.sort[0]?.dir as "asc" | "desc") : undefined
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onView={(id) =>
              nav({
                to: "/app/shops/$id",
                params: { id },
                search: { ...search },
              })
            }
            onVerify={(id) =>
              nav({
                to: "/app/shops/$id/verify",
                params: { id },
                search: { ...search },
              })
            }
            onBranches={(id) =>
              nav({
                to: "/app/shops/$id/branches",
                params: { id },
                search: { ...search },
              })
            }
            onFeeSettings={(id) =>
              nav({
                to: "/app/fees",
                search: { tab: "by_shop", shopId: id },
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
